import {formatMoney} from '@shopify/theme-currency';

const selectors = {
  saleClass: ' is-sale',
  soldClass: ' is-sold-out',
  badgeClass: ' product-status-flag--',
  customBadgeClass: ' product-status-flag--custom',
};

export function formatPrices(product) {
  const badgeStyle = theme.settings.productBadgeStyle;
  const onSale = product.price <= product.compare_at_price_min;
  const soldOut = !product.available;
  let badgeText;
  let badgeClasses = `${selectors.badgeClass}${badgeStyle}`;
  let customBadge = false;
  let preorder = false;

  for (let i = 0; i < product.tags.length; i++) {
    if (product.tags[i].includes('_badge_')) {
      customBadge = true;
      badgeText = product.tags[i].replace('_badge_', '').split('_').join(' ');
      badgeClasses += selectors.customBadgeClass;
      break;
    }
    if (product.tags[i].includes('_preorder')) {
      preorder = true;
      break;
    }
  }

  if (!customBadge) {
    if (soldOut) {
      badgeText = theme.translations.sold_out;
      badgeClasses += selectors.soldClass;
    } else if (preorder) {
      badgeText = theme.translations.pre_order;
      badgeClasses += selectors.customBadgeClass;
    } else if (onSale) {
      badgeText = theme.translations.on_sale;
      badgeClasses += selectors.saleClass;
    }
  }

  // New line required to prevent ellipse when style is set to "circle"
  if (badgeStyle == 'circle' && badgeText) {
    badgeText = badgeText.replace(' ', '<br>');
  }

  // Add 'from' before min prive if price varies
  product.price = formatMoney(product.price, moneyFormat);
  product.price_with_from = product.price;
  if (product.price_varies) {
    let min = formatMoney(product.price_min, moneyFormat);
    product.price_with_from = `${theme.translations.from} ${min}`;
  }

  if (product.compare_at_price) {
    // if on sale
    product.compare_at_price = formatMoney(product.compare_at_price, moneyFormat);
  }

  const formatted = {
    ...product,
    badgeClasses,
    badgeText,
  };
  return formatted;
}
